module.exports = __webpack_public_path__ + "media/application/images/icons/clipboard-22cc7ef96137a5ad32077cfb40ed562a.svg";